<template>
  <div class="layout">
    <el-container>
      <el-aside ref="elaside" width="200px">
        <sidebar />
      </el-aside>
      <el-container>
        <el-header>
          <navbar />
        </el-header>
        <el-main id="elmain" ref="elmain">
          <!-- 首页 -->
          <!-- <img v-if="showBackground" src="../../../assets/images/login/home.png" width='100%'> -->
          <div v-if="showBackground" class="home_page">
            <div v-loading="localLoading">
              <el-row class="userState" :gutter="12">
                <el-col :span="6">
                  <div class="box_statu">
                    <div class="box_top">
                      <div class="box_top_left">
                        <img
                          src="../../../assets/images/login/web.png"
                          class="api"
                        />
                        <p class="web">网站</p>
                      </div>
                      <div class="export_box">
                        <button
                          class="exportClass"
                          @click="exportStatisticalUserList"
                        >
                          导出
                        </button>
                      </div>
                    </div>
                    <div class="box_bottom">
                      <p class="box_p1">总注册量</p>
                      <p class="box_p2">{{ report.webTotal }}</p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="box_statu">
                    <div class="box_top">
                      <div class="box_top_left">
                        <img
                          src="../../../assets/images/login/web.png"
                          class="api"
                        />
                        <p class="web">网站</p>
                      </div>
                      <div class="box_top_right">
                        <p
                          v-for="(item, index) in report.dataList"
                          :key="index"
                          class="box_day"
                          :class="acitveNum == index ? 'box_day_active' : ''"
                          @click="clickDay(item, index)"
                        >
                          {{ item.day }}
                        </p>
                      </div>
                    </div>
                    <div class="box_bottom">
                      <p class="box_p1">新增客户</p>
                      <p class="box_p2">{{ activeTotla }}</p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="box_statu">
                    <div class="box_top">
                      <div class="box_top_left">
                        <img
                          src="../../../assets/images/login/web.png"
                          class="api"
                        />
                        <p class="web">网站</p>
                      </div>
                      <el-tooltip
                        content="周留存率 = (上周新增用户在本周登录过网站的人数)/(上周新增用户数)"
                        placement="top"
                      >
                        <div class="box_top_left">
                          <img
                            src="../../../assets/images/login/question.png"
                            class="question"
                          />
                        </div>
                      </el-tooltip>
                    </div>
                    <div class="box_bottom">
                      <p class="box_p1">周留存率</p>
                      <p class="box_p2">{{ report.weeksRetentionRates }}%</p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="box_statu">
                    <div class="box_top">
                      <div class="box_top_left">
                        <img
                          src="../../../assets/images/login/web.png"
                          class="api"
                        />
                        <p class="web">网站</p>
                      </div>
                      <el-tooltip placement="top">
                        <div class="box_top_left">
                          <img
                            src="../../../assets/images/login/question.png"
                            class="question"
                          />
                        </div>
                        <div slot="content">
                          月留存率 =
                          (上个月新增用户在本月登录过网站的人数)/(上个月新增用户数)
                        </div>
                      </el-tooltip>
                    </div>
                    <div class="box_bottom">
                      <p class="box_p1">月留存率</p>
                      <p class="box_p2">{{ report.monthRetentionRates }}%</p>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <!-- 新增网站 -->
              <el-row class="userState1" :gutter="12">
                <el-col :span="6">
                  <div class="box_statu">
                    <div class="box_top">
                      <div class="box_top_left">
                        <img
                          src="../../../assets/images/login/web.png"
                          class="api"
                        />
                        <p class="web">网站</p>
                      </div>
                      <el-tooltip placement="top">
                        <div class="box_top_left">
                          <img
                            src="../../../assets/images/login/question.png"
                            class="question"
                          />
                        </div>
                        <div slot="content">
                          活跃用户 =
                          (近30天内网站登录天数≥3，并且网站查询记录≥5的用户数)
                        </div>
                      </el-tooltip>
                    </div>
                    <div class="box_bottom">
                      <p class="box_p1">活跃用户数</p>
                      <p class="box_p2">{{ report.activeUserCount }}</p>
                    </div>
                  </div>
                </el-col>

                <el-col :span="6">
                  <div class="box_statu">
                    <div class="box_top">
                      <div class="box_top_left">
                        <img
                          src="../../../assets/images/login/web.png"
                          class="api"
                        />
                        <p class="web">网站</p>
                      </div>
                    </div>
                    <div class="box_bottom">
                      <p class="box_p1">昨日在线人数</p>
                      <p class="box_p2">{{ report.yesterdayCount }}</p>
                    </div>
                  </div>
                </el-col>

                <el-col :span="6">
                  <div class="box_statu">
                    <div class="box_top">
                      <div class="box_top_left">
                        <img
                          src="../../../assets/images/login/api.png"
                          class="api"
                        />
                        <p class="web">API</p>
                      </div>
                    </div>
                    <div class="box_bottom">
                      <p class="box_p1">账号开通总量</p>
                      <p class="box_p2">{{ report.apiTotal }}</p>
                    </div>
                  </div>
                </el-col>

                <el-col :span="6">
                  <div class="box_statu">
                    <div class="box_top">
                      <div class="box_top_left">
                        <img
                          src="../../../assets/images/login/api.png"
                          class="api"
                        />
                        <p class="web">API</p>
                      </div>
                    </div>
                    <div class="box_bottom">
                      <p class="box_p1">付费客户</p>
                      <p class="box_p2">{{ report.apiTotalCharged }}</p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>

            <notifica ref="allnotifications" style="margin-top: 10px" />

            <el-row :gutter="12" style="margin-top: 10px">
              <el-col :span="12">
                <firstlog-chart
                  @update:service="firstlogMultiDimensionTable.service = $event"
                  @update:btm="firstlogMultiDimensionTable.btm = $event"
                  @update:etm="firstlogMultiDimensionTable.etm = $event"
                />
              </el-col>
              <el-col :span="12">
                <firstlog-multi-dimension-table
                  :btm.sync="firstlogMultiDimensionTable.btm"
                  :etm.sync="firstlogMultiDimensionTable.etm"
                  :service.sync="firstlogMultiDimensionTable.service"
                  :services.sync="firstlogMultiDimensionTable.services"
                />
              </el-col>
            </el-row>

            <el-row :gutter="12" style="margin-top: 10px">
              <el-col :span="12">
                <thirdlog-chart />
              </el-col>
            </el-row>

            <!-- <el-card>
              <div slot="header">
                <span>所有通知</span>
              </div>
            </el-card>
            <p class="header_p">消息</p>
            <div class="home_main">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="所有通知" name="notifica">
                  <notifica ref="allnotifications"></notifica>
                </el-tab-pane>
              </el-tabs>
            </div> -->
          </div>
          <!-- 右测内容 -->
          <app-main v-else />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import sidebar from './sidebar/index.vue'
import navbar from './navbar/index.vue'
import appMain from './appMain.vue'
import notifica from './notifica.vue'
import loading from '@/components/Loading/outLoading.vue'
import FirstlogChart from '@/views/page/logs/FirstlogChart.vue'
import FirstlogMultiDimensionTable from '@/views/page/logs/FirstlogMultiDimensionTable.vue'
import ThirdlogChart from '@/views/page/logs/ThirdlogChart.vue'

import dayjs from 'dayjs'

export default {
  components: {
    loading,
    sidebar,
    navbar,
    appMain,
    notifica,
    FirstlogChart,
    ThirdlogChart,
    FirstlogMultiDimensionTable,
  },
  data() {
    const now = dayjs(),
      etm = now.add(1, 'd').format('YYYY-MM-DD'),
      btm = now.format('YYYY-MM-DD')
    return {
      firstlogMultiDimensionTable: {
        btm,
        etm,
        service: '',
        services: [],
      },

      localLoading: '',
      showBackground: false,
      activeName: 'notifica',

      //当前点击
      acitveNum: 0,
      activeTotla: '',

      report: {
        // 周留存率
        weeksRetentionRates: '',
        // 月留存率
        monthRetentionRates: '',
        webTotal: '', // 网站总数
        // 活跃用户
        activeUserCount: '',
        yesterdayCount: 0,
        apiTotalCharged: '', // API总付费数
        apiTotal: '', // API总数
        dataList: [
          {
            day: '昨日',
            total: '',
          },
          {
            day: '近一周',
            total: '',
          },
          {
            day: '近30天',
            total: '',
          },
        ],
      },
    }
  },
  computed: {
    sidebarOpen() {
      if (this.$route.path == '/Home') {
        this.showBackground = true
        this.handNumber()
      } else {
        this.showBackground = false
      }
      return this.$store.state.app.sidebar.opened
    },
  },
  watch: {
    sidebarOpen: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal === true) {
          this.$nextTick(() => {
            this.$refs.elmain.$vnode.elm.style.marginLeft = '200px'
            this.$refs.elaside.$vnode.elm.style.width = '200px'
          })
        } else {
          this.$nextTick(() => {
            this.$refs.elmain.$vnode.elm.style.marginLeft = '64px'
            this.$refs.elaside.$vnode.elm.style.width = '64px'
          })
        }
      },
    },
  },
  mounted() {
    this.handNumber()
    this.getReport()
  },
  methods: {
    handleClick() {},
    handNumber() {
      var that = this
      this.$axios
        .get(this.commonJs.localUrl + `/schedules/userManager/getUnRemind`, {
          headers: {
            Authorization: `Bearer ${this.getAuthorization()}`,
            AccessToken: this.getCookie('token'),
          },
        })
        .then(res => {
          if (res.data.status == 1) {
            that.$store.commit('handeCount', res.data.content)
          } else if (res.data.status == 0) {
            this.$message({
              type: 'error',
              message: '数据加载失败 请重新加载页面',
            })
          }
        })
    },
    getReport() {
      this.localLoading = true
      var that = this
      this.$axios
        .get(this.commonJs.localUrl + `/schedules/userManager/report`, {
          headers: {
            Authorization: `Bearer ${this.getAuthorization()}`,
            AccessToken: this.getCookie('token'),
          },
        })
        .then(res => {
          if (res.data.status == 1) {
            that.report.webTotal = res.data.content.webTotal
              ? res.data.content.webTotal
              : 0
            that.report.apiTotalCharged = res.data.content.apiTotalCharged
              ? res.data.content.apiTotalCharged
              : 0
            that.report.apiTotal = res.data.content.apiTotal
              ? res.data.content.apiTotal
              : 0

            that.report.dataList[0].total = res.data.content.webYesterday
              ? res.data.content.webYesterday
              : 0 //昨日
            that.report.dataList[1].total = res.data.content.webWeek
              ? res.data.content.webWeek
              : 0 //近一周
            that.report.dataList[2].total = res.data.content.webMonth
              ? res.data.content.webMonth
              : 0 //近30天

            that.activeTotla = res.data.content.webYesterday
              ? res.data.content.webYesterday
              : 0 //昨日
            // 周留存率
            that.report.weeksRetentionRates = res.data.content
              .weeksRetentionRates
              ? res.data.content.weeksRetentionRates
              : 0
            // 月留存率
            that.report.monthRetentionRates = res.data.content
              .monthRetentionRates
              ? res.data.content.monthRetentionRates
              : 0
            // 活跃用户
            that.report.activeUserCount = res.data.content.activeUserCount
              ? res.data.content.activeUserCount
              : 0
            that.report.yesterdayCount = res.data.content.yesterdayCount
              ? res.data.content.yesterdayCount
              : 0
          }
          this.localLoading = false
        })
    },
    clickDay(item, index) {
      this.acitveNum = index
      this.activeTotla = item.total
    },
    // 导出三十天内统计数据
    exportStatisticalUserList() {
      this.$axios({
        method: 'POST',
        url: this.commonJs.localUrl + `/schedules/exportStatisticalUserList`,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${this.getAuthorization()}`,
          AccessToken: this.getCookie('token').replace('Bearer', 'Jwt'),
        },
      }).then(res => {
        debugger
        let url = window.URL.createObjectURL(res.data)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        let contentDisposition = res.headers['content-disposition']
        if (contentDisposition) {
          let fileName = res.headers['content-disposition'].split('filename=')
          link.setAttribute('download', fileName[1])
          document.body.appendChild(link)
          link.click()
        } else {
          this.$message.error('暂无数据')
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.el-header {
  padding: 0;
  height: 50px !important;
}

::v-deep.el-main {
  padding: 0;
  position: absolute;
  top: 50px;
  overflow-y: auto;
  left: 0;
  right: 0;
  bottom: 0;
  margin-left: 200px;
}

.localLoading {
  ::v-deep.el-loading-text {
    color: #000;
    font-size: 16px;
    display: inline;
  }

  ::v-deep.el-loading-spinner i {
    color: #000;
    font-size: 16px;
  }

  ::v-deep.el-loading-spinner {
    margin-left: 40%;
    width: 13%;
  }
}

.userState {
  // width: 100%;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  // flex-wrap: nowrap;
  // overflow-x: auto;
}

.userState1 {
  margin-top: 10px;
}

.box_statu {
  height: 146px;
  background: #fff;
}

.last_statu {
  margin-right: 0px;
}

.box_top {
  height: 45px;
  margin: 0 10px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  min-width: 220px;
  justify-content: space-between;
}

.box_top_left {
  display: flex;
  align-items: center;

  .api {
    width: 24px;
    height: 24px;
  }

  .web {
    color: #333333;
    font-size: 12px;
    margin-left: 10px;
  }

  .question {
    width: 20px;
    height: 20px;
  }
}

.box_top_right {
  display: flex;
  align-items: center;

  .box_day {
    padding: 2px 10px;
    height: 20px;
    line-height: 20px;
    cursor: pointer;
    text-align: center;
    color: #333333;
  }

  .box_day_active {
    background-color: #3bafda;
    border-radius: 4px;
    color: #ffffff;
  }
}

.export_box {
  display: flex;
  align-items: center;

  .exportClass {
    background-color: #3bafda;
    border-radius: 4px;
    border: 3px solid #3bafda;
    color: #ffffff;
  }
}

.box_bottom {
  width: 100%;
  height: 101px;
  overflow: hidden;
}

.box_p1 {
  text-align: center;
  font-size: 12px;
  color: #606266;
  margin-top: 20px;
}

.box_p2 {
  text-align: center;
  font-size: 30px;
  color: #333333;
  font-weight: 600;
  margin-top: 10px;
}

.home_page {
  position: relative;
  padding: 20px 20px 20px 20px;
  overflow: hidden;
}

.home_main {
  .el-tabs {
    background-color: #fff;
    padding: 10px 0px 20px 0px;
  }

  ::v-deep.el-tabs__item.is-active {
    color: #333;
    font-weight: bold;
  }

  ::v-deep.el-tabs__item:hover {
    color: #333;
  }

  ::v-deep.el-tabs__item {
    font-size: 13px;
  }

  ::v-deep.el-tabs__nav-scroll {
    padding-left: 20px;
  }
}

.header_p {
  color: #22527d;
  font-size: 14px;
  padding-bottom: 10px;
}

.content {
  height: 20px;
}
</style>
